export const useTwicpicsURL = () => {
  const config = useRuntimeConfig()
  return new URL(config.public.twicpics.domain)
}
